module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box clear",
    style: ({
      marginLeft: _vm.left
    })
  }, [_c('div', {
    staticClass: "box-contain left"
  }, [(_vm.currentNavCon.comps && _vm.currentNavCon.comps.length) ? _c('ul', _vm._l((_vm.currentNavCon.comps), function(com, i) {
    return (_vm.currentNavCon.comps.length > 0) ? _c('li', {
      key: i,
      staticClass: "nav-con-item",
      class: {
        first: i === 0
      }
    }, [(com.cpnCode === 'def') ? _c('div', [_c('div', {
      staticClass: "nav-title"
    }, [_c('div', [_c('span', {
      style: ({
        color: _vm.color
      })
    }, [_vm._v(_vm._s(com.cpnTitle))])])]), _vm._v(" "), _c('div', {
      staticClass: "v-html",
      staticStyle: {
        "padding": "15px",
        "overflow-x": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(com.cpnContent)
      }
    })]) : _vm._e(), _vm._v(" "), (com.cpnCode === 'info') ? _c('div', [_c('div', {
      staticClass: "nav-title",
      style: ({
        color: _vm.color
      })
    }, [_c('div', [_vm._v("\n              " + _vm._s(com.cpnTitle) + "\n            ")])]), _vm._v(" "), _c('consultation', {
      staticStyle: {
        "padding": "12px"
      },
      attrs: {
        "color": _vm.color,
        "data": com.cpnData
      }
    })], 1) : _vm._e(), _vm._v(" "), (com.cpnCode === 'vip') ? _c('teacher', {
      attrs: {
        "data": com
      }
    }) : _vm._e(), _vm._v(" "), (com.cpnCode === 'live') ? _c('livecom', {
      staticClass: "nav-con-item",
      attrs: {
        "color": _vm.color,
        "data": com
      }
    }) : _vm._e(), _vm._v(" "), (com.cpnCode === 'cal') ? _c('daily', {
      attrs: {
        "color": _vm.color,
        "data": com
      }
    }) : _vm._e()], 1) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.currentNavCon && !_vm.currentNavCon.comps) ? _c('ul', [_c('li', {
    staticClass: "nav-con-item"
  }, [(_vm.currentNavCon.cpnCode === 'def') ? _c('div', [_c('div', {
    staticClass: "nav-title"
  }, [_c('div', [_c('span', {
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.currentNavCon.cpnTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "v-html",
    staticStyle: {
      "padding": "15px",
      "min-height": "270px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentNavCon.cpnContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentNavCon.cpnCode === 'info') ? _c('div', [_c('div', {
    staticClass: "nav-title",
    style: ({
      color: _vm.color
    })
  }, [_c('div', [_vm._v("\n              " + _vm._s(_vm.currentNavCon.cpnTitle) + "\n            ")])]), _vm._v(" "), _c('consultation', {
    staticStyle: {
      "padding": "12px"
    },
    attrs: {
      "color": _vm.color,
      "data": _vm.currentNavCon.cpnData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentNavCon.cpnCode === 'vip') ? _c('teacher', {
    attrs: {
      "color": _vm.color,
      "data": _vm.currentNavCon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentNavCon.cpnCode === 'cal') ? _c('daily', {
    attrs: {
      "color": _vm.color,
      "data": _vm.currentNavCon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentNavCon.cpnCode === 'live') ? _c('livecom', {
    staticClass: "nav-con-item",
    attrs: {
      "color": _vm.color,
      "data": _vm.currentNavCon
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-contain left"
  }, [(_vm.status == 1) ? _c('div', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "nav-title"
  }, [_c('div', [_c('span', {
    staticClass: "show-more back",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.curObj.cpnTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "v-html",
    staticStyle: {
      "padding": "15px",
      "min-height": "270px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.curObj.cpnContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.status == 2) ? _c('div', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('div', [_c('div', {
    staticClass: "nav-title"
  }, [_c('div', [_c('span', {
    staticClass: "show-more back",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.curObj.cpnTitle) + "\n          ")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "dt"
  }, _vm._l((_vm.curObj.cpnData), function(d, j) {
    return _c('li', {
      key: j,
      staticClass: "clear"
    }, [_c('b', {
      staticClass: "tip",
      style: ({
        backgroundColor: _vm.color
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "left"
    }, [_vm._v(_vm._s(d.infoTitle))]), _vm._v(" "), _c('p', {
      staticClass: "right time"
    }, [_vm._v("\n            " + _vm._s(_vm._f("date1")(d.infoDt)) + "\n          ")])])
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c3dba1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl3/render-components.vue
// module id = 766
// module chunks = 10